import { render, staticRenderFns } from "./jcList.vue?vue&type=template&id=0844f83e&"
import script from "./jcList.vue?vue&type=script&lang=js&"
export * from "./jcList.vue?vue&type=script&lang=js&"
import style0 from "./jcList.vue?vue&type=style&index=0&id=0844f83e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports